<template>
  <div class="ph-tool">
    <div class="editor-pane">
      <div class="pane-header">
        <span class="pane-dot input-dot" /><span class="pane-label">{{ $t('tool.PhoneList.title') }}</span>
        <span class="pane-hint">{{ $t('tool.PhoneList.totalRecords', { n: totalCount }) }}</span>
      </div>
      <el-input v-model="keyword" size="small" :placeholder="$t('tool.PhoneList.search')" clearable prefix-icon="el-icon-search" class="ph-search" />
    </div>

    <div class="ph-card" v-for="group in filteredGroups" :key="group.name">
      <div class="ph-group">
        <div class="ph-group-hd">
          <span class="ph-group-icon">{{ ICONS[group.key] || '📋' }}</span>
          {{ group.name }}
          <span class="ph-group-cnt">{{ group.items.length }}</span>
        </div>
        <div class="ph-grid">
          <div v-for="item in group.items" :key="item.name" class="ph-item" @click="copy(item.phone)">
            <span class="ph-item-name">{{ item.name }}</span>
            <code class="ph-item-num">{{ item.phone }}</code>
          </div>
        </div>
      </div>
    </div>
    <div class="ph-empty" v-if="keyword && !filteredGroups.length">{{ $t('tool.PhoneList.notFound') }}</div>
  </div>
</template>

<script>
var PHONES = {
  emergency:{police:'110',fire:'119',ambulance:'120',traffic:'122',smsPolice:'12110',forestFire:'12119',seaRescue:'12395',redCross:'999'},
  life:{dirAssist:'114',weather:'12121',time:'12117',electric:'95598',water:'12319',gas:'96777',tv:'96366',community:'12349'},
  telecom:{cmcc:'10086',cucc:'10010',ct:'10000',cbn:'10099',phoneFault:'112',netReport:'12321'},
  bank:{icbc:'95588',abc:'95599',boc:'95566',ccb:'95533',bocom:'95559',cmb:'95555',psbc:'95580',citic:'95558',spdb:'95528',unionpay:'95516',alipay:'95188',wechatPay:'95017'},
  express:{ems:'11183',sf:'95338',zto:'95311',yto:'95554',sto:'95543',yd:'95546',jd:'950616',deppon:'95353',jtexpress:'956025',cainiao:'9519666'},
  traffic:{railway:'12306',airline:'12326',highwayRescue:'12122',roadRescue:'12328',didi:'4000000999'},
  gov:{govService:'12345',consumer:'12315',quality:'12365',tax:'12366',env:'12369',discipline:'12388',legalAid:'12348',socialSecurity:'12333',housingFund:'12329',health:'12320',culture:'12318'},
  insurance:{picc:'95518',chinalife:'95519',pingan:'95511',cpic:'95500',taiping:'95589'},
  ecommerce:{taobao:'9510211',jdcom:'950618',pinduoduo:'4008822528',douyin:'95152',meituan:'10109777',eleme:'10105757',ctrip:'95010'},
  airline:{airchina:'95583',eastern:'95530',southern:'95539',hainan:'95339',xiamen:'95557',sichuan:'95378',shenzhen:'95361',spring:'95524'}
}
var ICONS = {emergency:'🔴',life:'🏠',telecom:'📶',bank:'🏦',express:'📦',traffic:'🚗',gov:'🏛️',insurance:'🛡️',ecommerce:'🛒',airline:'✈️'}

export default {
  name:'PhoneListTool',props:{config:{type:Object,default:()=>({})}},
  data:()=>({keyword:'',phoneData:[],totalCount:0,ICONS:ICONS}),
  created:function(){this.buildData();this.$watch(function(){return this.$i18n.locale},this.buildData.bind(this))},
  computed:{
    filteredGroups(){var kw=this.keyword.trim().toLowerCase();if(!kw)return this.phoneData;return this.phoneData.map(function(g){return{name:g.name,key:g.key,items:g.items.filter(function(i){return i.name.toLowerCase().includes(kw)||i.phone.includes(kw)})}}).filter(function(g){return g.items.length})}
  },
  methods:{
    buildData:function(){
      var gs=this.$t('tool.PhoneList.groups'),self=this,data=[],total=0
      Object.keys(PHONES).forEach(function(k){var g=gs[k];var items=Object.keys(PHONES[k]).map(function(ik){total++;return{name:g.items[ik],phone:PHONES[k][ik]}});data.push({name:g.name,key:k,items:items})})
      this.phoneData=data;this.totalCount=total
    },
    copy(t){navigator.clipboard.writeText(t);this.$message.success(this.$t('tool.PhoneList.copied',{phone:t}))},
    doAction(a){if(a==='clear')this.keyword=''}
  }
}
</script>

<style scoped>
.ph-tool { display:flex;flex-direction:column;gap:12px; }
.editor-pane { background:#fafbfc;border-radius:12px;border:1px solid #ebeef5;padding:16px 20px; }
.pane-header { display:flex;align-items:center;gap:8px;margin-bottom:12px; }
.pane-dot { width:8px;height:8px;border-radius:50%;flex-shrink:0; }
.input-dot { background:#4e7cff;box-shadow:0 0 6px rgba(78,124,255,.4); }
.pane-label { font-size:13px;font-weight:700;color:#1a1f36; }
.pane-hint { font-size:11px;color:#b0b8c4;margin-left:auto; }
.ph-search { }

/* card */
.ph-card { background:#fff;border-radius:12px;border:1px solid #ebeef5;overflow:hidden; }
.ph-group { padding:16px 20px 14px; }
.ph-group-hd { display:flex;align-items:center;gap:8px;font-size:14px;font-weight:700;color:#1a1f36;margin-bottom:12px;padding-bottom:10px;border-bottom:1px solid #f5f6f8; }
.ph-group-icon { font-size:16px;width:32px;height:32px;display:flex;align-items:center;justify-content:center;background:#f5f6f8;border-radius:8px; }
.ph-group-cnt { font-size:11px;font-weight:500;color:#8892a6;margin-left:auto;background:#f5f6f8;padding:2px 10px;border-radius:10px;letter-spacing:.5px; }

/* grid */
.ph-grid { display:grid;grid-template-columns:repeat(auto-fill,minmax(170px,1fr));gap:8px; }
.ph-item { display:flex;align-items:center;justify-content:space-between;padding:7px 14px;background:#fafbfc;border-radius:8px;cursor:pointer;transition:all .15s;border:1px solid transparent;gap:8px; }
.ph-item:hover { background:#f0f4ff;border-color:#d0ddf8;transform:translateY(-1px);box-shadow:0 2px 6px rgba(78,124,255,.08); }
.ph-item-name { font-size:13px;color:#4a5568;white-space:nowrap; }
.ph-item-num { font-family:'JetBrains Mono','Consolas',monospace;font-size:13px;color:#4e7cff;font-weight:600;white-space:nowrap; }
.ph-empty { text-align:center;padding:40px;font-size:13px;color:#b0b8c4; }
</style>
